/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_Type_MismatchInputs */

const cs_client_merge_type_mismatch = /** @type {(inputs: Client_Merge_Type_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno se neshoduje.`)
};

const en_client_merge_type_mismatch = /** @type {(inputs: Client_Merge_Type_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name does not match.`)
};

/**
* | output |
* | --- |
* | "Name does not match." |
*
* @param {Client_Merge_Type_MismatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_type_mismatch = /** @type {((inputs?: Client_Merge_Type_MismatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_Type_MismatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_type_mismatch(inputs)
	return cs_client_merge_type_mismatch(inputs)
});